<template>
    <a-menu theme="dark" mode="inline" :selected-keys="[currentKey]">
        <a-menu-item v-for="item in items" :key="item.link">
            <a-tooltip v-if="item.locked" placement="right">
                <template #title>
                    <div class="lock-tip">
                        <strong>{{ item.text }}</strong>
                        <span>Locked · book a demo for full access</span>
                    </div>
                </template>

                <span class="nav-locked">
                    <component :is="item.icon" />
                    <span class="nav-text">{{ item.text }}</span>
                    <lock-outlined class="lock-icon" />
                </span>
            </a-tooltip>

            <router-link v-else :to="item.link">
                <component :is="item.icon" />

                <span class="nav-text">{{ item.text }}</span>
            </router-link>
        </a-menu-item>
    </a-menu>
</template>

<script>
import {
    MailOutlined,
    SearchOutlined,
    ProjectOutlined,
    QuestionCircleOutlined,
    LockOutlined
} from '@ant-design/icons-vue';
import HelperIcon from '@/assets/images/components/helper-icon';
import { mapGetters } from 'vuex';

export default {
    components: {
        MailOutlined,
        SearchOutlined,
        ProjectOutlined,
        HelperIcon,
        QuestionCircleOutlined,
        LockOutlined
    },

    props: {
        currentKey: {
            type: String,
            required: true
        }
    },

    computed: {
        ...mapGetters({
            isProdOrPreprod: 'environments/isProdOrPreprod',
            isMcpUser: 'auth/isMcpUser'
        }),

        items() {
            const items = [
                {
                    text: 'Dashboard',
                    link: '/', // @TMP
                    icon: 'project-outlined'
                }
            ];

            if (!this.isProdOrPreprod) {
                items.push(
                    {
                        text: 'Inbox',
                        link: '/inbox',
                        icon: 'mail-outlined'
                    },
                    {
                        text: 'Live Search',
                        link: '/search',
                        icon: 'search-outlined'
                    },
                    {
                        text: 'Helper',
                        link: '/helper',
                        icon: 'helper-icon'
                    },
                    {
                        text: 'How To',
                        link: '/how_to',
                        icon: 'question-circle-outlined'
                    },
                );
            }

            // Sandbox accounts see the full menu, but every item is locked
            if (this.isMcpUser) {
                return items.map(item => ({ ...item, locked: true }));
            }

            return items;
        }
    }
};
</script>

<style scoped>
.nav-locked {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: not-allowed;
    opacity: 0.55;
}

.nav-locked .nav-text {
    margin-left: 10px;
}

.lock-icon {
    margin-left: auto;
    font-size: 12px;
}

.lock-tip strong {
    display: block;
    margin-bottom: 2px;
}
</style>